import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.collection.content}}
  <ul class="select-kit-errors-collection">
    {{#each this.collection.content as |item|}}
      <li class="select-kit-error">{{item}}</li>
    {{/each}}
  </ul>
{{/if}}
*/
{
  "id": "3/5ItbYH",
  "block": "[[[41,[30,0,[\"collection\",\"content\"]],[[[1,\"  \"],[10,\"ul\"],[14,0,\"select-kit-errors-collection\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,0,[\"collection\",\"content\"]]],null]],null],null,[[[1,\"      \"],[10,\"li\"],[14,0,\"select-kit-error\"],[12],[1,[30,1]],[13],[1,\"\\n\"]],[1]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"item\"],false,[\"if\",\"each\",\"-track-array\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/select-kit/errors-collection.hbs",
  "isStrictMode": false
});